/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.StandingAppointments {
    angular.module("meevo.plugins.standingAppointments", ['ApptBookApp']);
}